import { ReactNode } from 'react';
import { Space, Typography } from 'antd';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

type Props = {
    label: ReactNode;
    htmlFor: string;
    required?: boolean;
    hint?: ReactNode;
    children: ReactNode;
};

const FormField = ({ label, htmlFor, required = false, hint, children }: Props) => (
    <Space size={6} direction="vertical" style={{ width: '100%' }}>
        <label htmlFor={htmlFor}>
            {required && (
                <>
                    <LabelRequiredSymbol />{' '}
                </>
            )}
            {label}
        </label>
        {children}
        {hint && (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {hint}
            </Typography.Text>
        )}
    </Space>
);

export default FormField;
